import React from "react";
import AntdDescriptions, { DescriptionsProps } from "antd/lib/descriptions";
import { withError} from '@fishx/tracker';

const Item = AntdDescriptions.Item;
interface FCDescriptionsProps extends React.FC<DescriptionsProps> {
  Item: typeof Item;
}
export const Descriptions: FCDescriptionsProps = (props) => {
  const { children } = props;
  return <AntdDescriptions {...props}>{children}</AntdDescriptions>;
}
Descriptions.Item = Item;
Descriptions.displayName = 'Descriptions';
export default withError(Descriptions);



// WEBPACK FOOTER //
// ./src/components/descriptions/index.tsx